import {useEffect, useState} from "react";
import Bookings from "./Bookings";
import {IRestaurant} from "../../utils/interfaces/IRestaurant";
import Transactions from "./Transactions";
import {BiDish, BiSolidDish} from "react-icons/bi"
import {MdOutlineEditCalendar} from "react-icons/md"
import Rebounds from "./Rebounds";

interface RestaurantRowProps {
    obj: IRestaurant,
}

function RestaurantRow({obj: initialObj}: RestaurantRowProps) {
    const [obj, setObj] = useState<IRestaurant>(initialObj)
    const [selectedRestaurant, setSelectedRestaurant] = useState<IRestaurant>()

    const handleSelect = (obj: IRestaurant) => {
        (selectedRestaurant === obj) ?
            setSelectedRestaurant(undefined) :
            setSelectedRestaurant(obj);
    }
    
    let labelStyle = 'text-sm text-gray-500 font-bold mr-1 cursor-pointer ';
    let contentStyle = 'text-sm text-gray-800 font-bold mr-1 cursor-pointer ';

    useEffect(() => {
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj])


    return (
        <>
            <div
                className='flex flex-col gap-2 cursor-pointer bg-gray-300 shadow-xl rounded-lg px-4 py-2 mb-2 mt-2 '>
                <div
                    className="flex flex-1 flex-row "
                    onClick={() => handleSelect(obj)}
                >
                    <div
                        className="flex flex-1 flex-row "
                        onClick={() => handleSelect(obj)}
                    >
                        <label className={labelStyle}>Ristorante: </label>
                        <label className={contentStyle}>{obj.name}</label>
                        <div className="flex flex-1 flex-row ml-2 " style={{alignItems: 'center'}}>
                            <MdOutlineEditCalendar className='text-mcia_orange ml-2 mr-1' title='prenotazioni'/>
                            <label className='text-xs ml-0.5 text-gray-600'>{obj.bookings.totals.count}</label>
                            <BiDish className='text-mcia_orange ml-2 mr-0.5' title='ordini'/>
                            <label className='text-xs text-gray-600 ml-0.5'>{obj.transactions.totals.count}</label>
                        </div>

                    </div>

                </div>

                <div>

                    {obj.bookings.details.length > 0 &&
                        <div className="flex flex-col ml-0">
                            <Bookings obj={obj.bookings}/>
                        </div>}

                    {obj.rebounds.details.length > 0 &&
                        <div className="flex flex-col ml-0">
                            <Rebounds obj={obj.rebounds}/>
                        </div>}

                    {obj.transactions.details.length > 0 &&
                        <div className="flex flex-col ml-0">
                            <Transactions obj={obj.transactions}/>
                        </div>}

                </div>


            </div>
        </>
    );
}

export default RestaurantRow;